import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { ErrorPrefix } from "Constants/constants";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { VeteranAutoType } from "Store/interfaces/products/checkPrice/riskProducts/VehicleProducts/VeteranAuto";
import { VeteranAutoProductIntroFormValues } from "../veteranAutoInterface";

export const validationSchema =
  (): Yup.ObjectSchema<VeteranAutoProductIntroFormValues> => {
    const { getText } = TextManager;

    return Yup.object().shape({
      isInGoodCondition: Yup.mixed<BooleanFormType>()
        .notOneOf([BooleanFormType.FALSE], ErrorPrefix.BREAKING)
        .required(getText("veteranautoform.validation.isingoodcondition")),
      veteranAutoType: Yup.mixed<VeteranAutoType>().required(
        getText("veteranautoform.validation.veteranautotype"),
      ),
      firstRegistered: Yup.number().required(
        getText("veteranautoform.validation.firstregistered"),
      ),
      modelAndValue: Yup.string().required(
        getText("veteranautoform.validation.modelandvalue"),
      ),
      brandOrModel: Yup.string().required(
        getText("veteranautoform.validation.brandormodel"),
      ),
    });
  };
